export default function getRooms(locale: string) {
  const query = `_type=="press" && locale=="${locale}" && !(_id in path("drafts.**"))`;

  return groq`*[${query}] | order(orderRank asc) {
      ...
    }`;
}
